const PageNotFound = () => {
  return <div>page not Found 404</div>;
};

export default PageNotFound;
